import React, { useMemo } from "react";
import Popover from "@mui/material/Popover";
import {
  Card,
  CardContent,
  Box,
  CardActions,
  Typography,
  Grid,
} from "@mui/material";
import Buttons from "../../../library/custom/button/Button";
import FormLabels from "../../../library/custom/formLabel/FormLabels";
import SelectMenu from "../../../library/custom/selectMenu/SelectMenu";
import "./FilterCommonStatusSelect.scss";
import { getLabelByAssetType, getNoOptionsTextByAssetType, sortAlphabetically } from "../../../utils/helper";
import FromToDatePicker from "../../../library/custom/datePicker/DatePicker";
import { ASSETTYPE } from "../../../constant/inspectionConstant";
import { INS_STATUS } from "../../../constant/constant";
import SearchAutoComplete2 from "../../../library/custom/searchAutoComplete/SearchAutoComplete";

const InsFilter = ({
  id,
  open,
  anchorEl,
  handleClose,
  handleApply,
  handleClear,
  resetBtn = false,
  filterDate = false,
  toDate,
  fromDate,
  divisionList,
  toDateHandler,
  fromDateHandler,
  divisionOnChanges,
  divisionId,
  division = false,
  assetType = false,
  assetTypeId,
  assetTypeOnChanges,
  status = false,
  statusId,
  statusOnChanges,
  inspectionTypeOnChanges,
  inspectionTypeId,
  InspectionType = false,
  quesSet,
  categoryId,
  categoryOnChanges,
  vehicleCategories,
  equipmentCategories,
  customAssetCategories,
  assets,
  searchAsset,
  isAssetLoading,
  assetOption,
  handleAssetOnChange,
  autoSearch,
}) => {
  const sortedDivision = useMemo(() => {
    return sortAlphabetically(divisionList);
  }, [divisionList]);

  const sortedQuesSet = useMemo(() => {
    return sortAlphabetically(quesSet);
  }, [quesSet]);

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Card className="filterlist_of_cases">
          <CardContent>
            {filterDate && (
              <>
                <Box className="" sx={{ pb: 2 }}>
                  <Typography className="filterLabel" gutterBottom variant="h5">
                    Time Period
                  </Typography>

                  <Box className="datePicker_row">
                    <div>
                      <Typography variant="subtitle1">From</Typography>
                      <FromToDatePicker
                        value={fromDate}
                        onChangeHandler={(value) => fromDateHandler(value)}
                      />
                    </div>
                    <div>
                      <Typography variant="subtitle1">To</Typography>
                      <FromToDatePicker
                        value={toDate}
                        onChangeHandler={(value) => toDateHandler(value)}
                      />
                    </div>
                  </Box>
                </Box>
              </>
            )}

            {division && (
              <Box className="" sx={{ pb: 2 }}>
                <FormLabels label={"Division"} isRequired={false} />
                <SelectMenu
                  name={"division"}
                  listData={sortedDivision}
                  onchangehandler={(e) => divisionOnChanges(e)}
                  value={divisionId}
                  placeholder="Please select"
                />
              </Box>
            )}

            {assetType && (
              <Box className="" sx={{ pb: 2 }}>
                <FormLabels label={"Asset Type"} isRequired={false} />
                <SelectMenu
                  name={"assetType"}
                  listData={ASSETTYPE}
                  onchangehandler={(e) => assetTypeOnChanges(e)}
                  value={assetTypeId}
                  placeholder="Please select"
                />
              </Box>
            )}

            {assetTypeId && (assetTypeId === 3 || assetTypeId === 2 || assetTypeId === 4) && (
              <Box className="" sx={{ pb: 2 }}>
                <FormLabels
                  label={
                    assetTypeId === 3
                      ? "Vehicle Category"
                      : assetTypeId === 2
                        ? "Equipment Category"
                        : assetTypeId === 4
                          ? "Custom Asset Category"
                          : "Category"
                  }
                  isRequired={false}
                />
                <SelectMenu
                  name={"categoryId"}
                  listData={
                    assetTypeId === 3
                      ? vehicleCategories
                      : assetTypeId === 2
                        ? equipmentCategories
                        : assetTypeId === 4
                          ? customAssetCategories
                          : []
                  }
                  onchangehandler={(e) => categoryOnChanges?.(e)}
                  value={categoryId}
                  placeholder="Please select"
                />
              </Box>
            )}

            {assetTypeId && (
              <Grid container mb={2} spacing={2}>
                <Grid md={12} xs={12} item className="customLableIns">
                  <FormLabels
                    label={
                      assetTypeId === 2
                        ? "Make And Model And Serial Number"
                        : `${getLabelByAssetType(assetTypeId)} Name`
                    }
                    isRequired={false}
                  />
                  <SearchAutoComplete2
                    optionsData={isAssetLoading ? [] : (assetOption ?? [])}
                    isKeyValuePair={true}
                    value={assets}
                    isLoading={isAssetLoading}
                    noOptionsTextMsg={getNoOptionsTextByAssetType(assetTypeId)}
                    typeOnchange={(event) =>
                      searchAsset?.(
                        event.target.value,
                        assetTypeId,
                        categoryId === "AllCategory" ? 0 : categoryId ? categoryId : 0,
                        divisionId === "AllDivision" ? 0 : divisionId ? divisionId : 0,
                      )
                    }
                    onChange={(e, value) => handleAssetOnChange?.(value)}
                    autoCompClear={autoSearch}
                  />
                </Grid>
              </Grid>
            )}

            {InspectionType && (
              <Box className="" sx={{ pb: 2 }}>
                <FormLabels label={"Inspection Type"} isRequired={false} />
                <SelectMenu
                  name={"inspectionType"}
                  listData={sortedQuesSet}
                  onchangehandler={(e) => inspectionTypeOnChanges(e)}
                  value={inspectionTypeId}
                  placeholder="Please select"
                />
              </Box>
            )}

            {status && (
              <Box className="">
                <FormLabels label={"Status"} isRequired={false} />
                <SelectMenu
                  name={"status"}
                  listData={INS_STATUS}
                  onchangehandler={(e) => statusOnChanges(e)}
                  value={statusId}
                  placeholder="Please select"
                />
              </Box>
            )}
          </CardContent>
          <CardActions>
            {resetBtn && (
              <Buttons
                primary={true}
                label={"Reset"}
                onClick={(e) => handleClear(e)}
                size="small"
              />
            )}

            <Buttons
              primary={true}
              label={"Apply"}
              onClick={(e) => handleApply(e)}
              size="small"
            />
          </CardActions>
        </Card>
      </Popover>
    </>
  );
};

export default InsFilter;
